import { Box, Grid, Typography } from '@mui/material'
import { IconName } from '../../../../../../shared/interfaces/icon-picker.model'
import { SelectableCard } from '../../../../../presentation-components/settings-components/data-import/selectable-card'
import { FunctionComponent, useContext } from 'react'
import { ScreenLabelsContext } from '../../../../../../context/screen-labels/screen-labels'
import { UserDetailsContext } from '../../../../../../context/user-details/user-details'

export const DataTypeSelectionStep: FunctionComponent<{ onDataTypeSelect: (dataTypeId: string) => void }> = ({ onDataTypeSelect }) => {
  //Context
  const screenLabelsContext = useContext(ScreenLabelsContext)
  const userDetailsContext = useContext(UserDetailsContext)
  const organisation = userDetailsContext.userDetails?.organisation
  //Varibales
  const importOptions = [
    {
      id: 'emissions',
      title: 'Emissions',
      description: 'Import emissions data from various sources',
      icon: IconName.FilterDrama
    },
    {
      id: 'locations',
      title: screenLabelsContext.getLabel('location', { plural: true, capitalize: 'first' }),
      description: `Import ${screenLabelsContext.getLabel('location')} and facility information`,
      icon: IconName.HomeWorkOutlined
    },
    {
      id: 'vehicles',
      title: screenLabelsContext.getLabel('vehicle', { plural: true, capitalize: 'first' }),
      description: `Import ${screenLabelsContext.getLabel('vehicle')} fleet and transportation data`,
      icon: IconName.DirectionsCarOutlined
    },
    {
      id: 'products',
      title: screenLabelsContext.getLabel('product', { plural: true, capitalize: 'first' }),
      description: `Import ${screenLabelsContext.getLabel('product')} and materials information`,
      icon: IconName.Inventory2Outlined
    },
    ...organisation?.enableProjects ? [{
      id: 'projects',
      title: screenLabelsContext.getLabel('project', { plural: true, capitalize: 'first' }),
      description: `Import ${screenLabelsContext.getLabel('project')} and initiative information`,
      icon: IconName.AssignmentOutlined
    }] : []
    ,
    {
      id: 'suppliers',
      title: screenLabelsContext.getLabel('supplier', { plural: true, capitalize: 'first' }),
      description: `Import ${screenLabelsContext.getLabel('organisation')} ${screenLabelsContext.getLabel('supplier', { plural: true })}`,
      icon: IconName.LocalShippingOutlined
    }
  ]
  return (
    <Box sx={{ py: 1 }}>
      <Typography variant="h6" sx={{ mb: 2, textAlign: 'left' }}>
        Which type of data are you looking to import?
      </Typography>
      <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary', textAlign: 'left' }}>
        Select the correct data type below.
      </Typography>
      <Grid container spacing={3}>
        {importOptions.map((option) => (
          <Grid item xs={12} sm={6} md={4} key={option.id}>
            <SelectableCard
              align='left'
              fullHeight
              icon={option.icon}
              title={option.title}
              description={option.description}
              onClick={() => onDataTypeSelect(option.id)}
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  )
}
